// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__JoQqb","content":"Tabs_content__shhEG","floatingPill":"Tabs_floatingPill__-1lOw"};